'use strict';

export default {
  errors: {
    generic: 'An error occured',
    limitReached: 'The maximum number of submission has been reached',
    genericRefresh: 'An error occured. Please refresh the page and try again.',
    http: {
      400: 'Error 400',
      401: 'Error 401: Session expired',
      404: 'Error 404: Page not found',
      500: 'Error 500: Server error',
    },
  },
  success: {
    saved: 'Saved successfully',
  },
};
